var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnnotation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Annotation Text") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M31,11 L31,5 L25,5 L25,7 L15,7 L15,5 L9,5 L9,11 L11,11 L11,21 L9,21 L9,27 L15,27 L15,25 L25,25 L25,27 L31,27 L31,21 L29,21 L29,11 L31,11 L31,11 Z M11,7 L13,7 L13,9 L11,9 L11,7 L11,7 Z M13,25 L11,25 L11,23 L13,23 L13,25 L13,25 Z M25,23 L15,23 L15,21 L13,21 L13,11 L15,11 L15,9 L25,9 L25,11 L27,11 L27,21 L25,21 L25,23 L25,23 Z M29,25 L27,25 L27,23 L29,23 L29,25 L29,25 Z M27,9 L27,7 L29,7 L29,9 L27,9 L27,9 Z M21.73,18 L18.24,18 L17.51,20 L15.89,20 L19.29,11 L20.69,11 L24.1,20 L22.47,20 L21.73,18 L21.73,18 Z M18.69,16.74 L21.3,16.74 L20,12.91 L18.69,16.74 L18.69,16.74 Z",
    id: "path-4671"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DF4-Free-Text-Bounding-Box",
    transform: "translate(-105.000000, -127.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(95.000000, 87.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tool-List-Item",
    transform: "translate(0.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_format_shapes"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4671"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#4A4A4A",
    xlinkHref: "#path-4671"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotation);
export default __webpack_public_path__ + "static/media/Annotation.8e63f7ce925a343913cffb4c2412b7ae.svg";
export { ForwardRef as ReactComponent };